import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import alertify from 'alertifyjs';
import { ApiServiceService } from '../../../modules/services/api-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentVerificationResponse } from './payment-verification.model';
import { AuthenticationService } from '../../../modules/services/authentication.service';

@Component({
  selector: 'app-payment-verification',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './payment-verification.component.html',
  styleUrl: './payment-verification.component.scss'
})
export class PaymentVerificationComponent implements OnInit {
  payment: {
    amountPaid: string | number,
    paymentReference: string,
    description: string,
    transactionDate: string
  };
  transactionReference: string;
  status: "SUCCESSFUL" | "FAILED";
  isPaymentVerifying: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private apiService: ApiServiceService,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.isPaymentVerifying = true;
    const params = this.route.snapshot.params;
    const transactionReference = params['txnref'];

    if (!transactionReference) {
      alertify.error("Failed to get transaction reference");
      return;
    }

    this.transactionReference = transactionReference;
    this.verifyPayment();
  }
  verifyPayment() {
    this.isPaymentVerifying = true;
    this.apiService.post("/verify-payment", {"orderId": this.transactionReference}).subscribe(
      {
        next: (response: PaymentVerificationResponse) => {
          console.log(response);
          this.payment = {
            amountPaid: response.data.Amount,
            description: response.data.ResponseDescription,
            paymentReference: response.data.PaymentReference,
            transactionDate: response.data.TransactionDate
          }
          this.status = "SUCCESSFUL";
          this.isPaymentVerifying = false;
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            alertify.error(error.message)
          } else {
            alertify.error(JSON.stringify(error))
          }

          this.status = "FAILED";
          this.isPaymentVerifying = false
        },
      }
    )
  }

  goBack() {
    // this.router.navigate(["../"], {relativeTo: this.route});
    this.location.back();
  }

  downloadReceipt(): void {
    const receiptId = this.payment?.paymentReference || this.transactionReference;
    if (!receiptId) {
      alertify.error('Unable to start receipt download.');
      return;
    }

    const url = this.apiService.getReceiptDownloadUrlByReference(receiptId);
    const popup = window.open(url, '_blank', 'noopener,noreferrer');
    if (!popup) {
      alertify.message('Receipt opened in this tab because the browser blocked a new tab.');
    }
  }

  onBackToPayments() {
    const userAccountType = this.authService.getAccountType();

    switch (userAccountType) {
      case "ADMIN":
        this.router.navigate(["admin", "payments"]);
        return;
      
      case "USER":
        this.router.navigate(["user"]);
        return;

      default:
        return;
    }
  }
}
